import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { useErrorBoundary } from "component-library";
import { authAxios as axios } from "shared-auth";
import { HALManager, UserManager } from "core";
import { AboutMe } from "models";
import { useGetPublicProfile } from "pages/Profile/hooks/useGetPublicProfile";
import { usePublicView } from "pages/Profile/hooks/usePublicView";
import { getApiUrl } from "services/UrlBuilder";

export const GET_ABOUT_ME_QUERY_KEY = "GET_ABOUT_ME_QUERY_KEY";

export function useGetAboutMe() {
  const captureError = useErrorBoundary();
  const { isPublicView } = usePublicView();
  const { data: publicProfileData, isLoading: isPublicProfileLoading } =
    useGetPublicProfile();

  const {
    data: privateAboutMeData,
    isLoading: isPrivateAboutMeLoading,
  } = useQuery<AboutMe, AxiosError>(
    GET_ABOUT_ME_QUERY_KEY,
    async () => {
      const { data } = await axios.get(
        getApiUrl(HALManager.getAboutMeUrl(UserManager.userId))
      );

      return data;
    },
    {
      enabled: !isPublicView,
      cacheTime: 0,
      onError: captureError,
    }
  );

  const aboutMe = isPublicView
    ? publicProfileData?.aboutMe
    : privateAboutMeData;

  const isLoading = isPublicView
    ? isPublicProfileLoading
    : isPrivateAboutMeLoading;

  return {
    aboutMe,
    isLoading,
  };
}
